import { render, staticRenderFns } from "./ruleTable.vue?vue&type=template&id=5934a774&scoped=true"
import script from "./ruleTable.vue?vue&type=script&lang=js"
export * from "./ruleTable.vue?vue&type=script&lang=js"
import style0 from "./ruleTable.vue?vue&type=style&index=0&id=5934a774&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5934a774",
  null
  
)

export default component.exports